export enum EvId {
  settingPanelOpen = 400,
  button = 403,
  adView = 870,
}
export type EventName =
  | 'settings_panel_open_connect_account_old_users'
  | 'settings_panel_open_manage_account_not_connected'
  | 'settings_panel_open_manage_waiting_for_approval'
  | 'settings_panel_open_manage_account_connected_ad_not_connected'
  | 'settings_panel_open_manage_account_connected_ad_not_created'
  | 'settings_panel_open_manage_account_connected_ad_connected'
  | 'settings_panel_open_ads_tab_no_ads_created'
  | 'settings_panel_open_ads_tab_fixed_ad'
  | 'settings_panel_open_ads_tab_responsive_ad'
  | 'settings_panel_open_ads_tab_no_ads_connected'
  | 'settings_panel_open_support_tab'
  | 'click_button_support_tab_see_all_articles'
  | 'click_button_support_tab_wix_assitant'
  | 'click_button_support_tab_adsense_help'
  | 'click_button_support_tab_contact_customer_care'
  | 'click_button_manage_account_not_connected'
  | 'click_button_connect_account_old_users'
  | 'click_button_manage_waiting_for_approval'
  | 'click_button_manage_account_connected_ad_not_connected_connect_ad_unit'
  | 'click_button_manage_account_connected_ad_not_connected_manage_ads'
  | 'click_button_manage_account_connected_ad_not_created_create_ad_unit'
  | 'click_button_manage_account_connected_ad_not_created_manage_ads'
  | 'click_button_manage_account_connected_ad_connected'
  | 'click_button_manage_account_connected_ad_connected_duplicate_ad'
  | 'click_button_ads_tab_no_ads_created'
  | 'click_button_ads_tab_fixed_ad'
  | 'click_button_ads_tab_responsive_ad'
  | 'click_button_ads_tab_no_ads_connected'
  | 'live_site_ad_view'
  | 'live_site_ad_click'
  | '';

export type PageNameOrOrigin =
  | 'old_users_page'
  | 'manage_account_not_connected'
  | 'manage_waiting_for_approval'
  | 'manage_account_connected_ad_not_connected'
  | 'manage_account_connected_ad_not_created'
  | 'manage_account_connected_ad_connected'
  | 'ads_tab_no_ads_created'
  | 'ads_tab_fixed_ad'
  | 'ads_tab_responsive_ad'
  | 'ads_tab_no_ads_connected'
  | 'support_tab';

export type Description =
  | 'go_to_dashboard'
  | 'connect_account'
  | 'connect_ad_unit'
  | 'create_ad_unit'
  | 'manage_ads'
  | 'new_ad_unit'
  | 'duplicate_ad'
  | 'see_all_articles'
  | 'wix_assitant'
  | 'adsense_help'
  | 'contact_customer_care';

export type Params = {
  origin?: PageNameOrOrigin;
  page_name?: PageNameOrOrigin;
  description?: Description;
  evid?: EvId;
};
